import { AreaType, IArea, IGateEvent, IStateAwareArea } from 'types/map';
import asStateAwareArea from 'mapping/asStateAwareArea';

export default class Area implements IArea {
  readonly areaKey: string;
  readonly canMoveTo: boolean;
  readonly childAreas: IArea[];
  readonly description: string;
  readonly discovered: boolean;
  readonly gateEvent?: IGateEvent;
  readonly hideName: boolean;
  readonly hitbox: number[][] | undefined;
  readonly id: number;
  readonly image: string;
  readonly labelX: number | undefined;
  readonly labelY: number | undefined;
  readonly mainDestinationHitbox: number[][] | undefined;
  readonly mainDestinationSelectionSpriteTopLeftX: number | undefined;
  readonly mainDestinationSelectionSpriteTopLeftY: number | undefined;
  readonly mainDestinationSpriteTopLeftX: number | undefined;
  readonly mainDestinationSpriteTopLeftY: number | undefined;
  readonly moveMessage: string;
  readonly name: string;
  readonly premiumSubRequired: boolean;
  readonly showOps: boolean;
  readonly selectionSpriteTopLeftX: number | undefined;
  readonly selectionSpriteTopLeftY: number | undefined;
  readonly spriteTopLeftX: number | undefined;
  readonly spriteTopLeftY: number | undefined;
  readonly type: AreaType;
  readonly unavailableDescription: string;
  readonly unlocked: boolean;
  readonly zIndex: number;

  constructor(obj: IArea) {
    this.areaKey = obj.areaKey;
    this.canMoveTo = obj.canMoveTo;
    this.childAreas = obj.childAreas;
    this.description = obj.description;
    this.discovered = obj.discovered;
    this.gateEvent = obj.gateEvent;
    this.hideName = obj.hideName;
    this.hitbox = obj.hitbox;
    this.id = obj.id;
    this.image = obj.image;
    this.labelX = obj.labelX;
    this.labelY = obj.labelY;
    this.mainDestinationHitbox = obj.mainDestinationHitbox;
    this.mainDestinationSelectionSpriteTopLeftX = obj.mainDestinationSelectionSpriteTopLeftX;
    this.mainDestinationSelectionSpriteTopLeftY = obj.mainDestinationSelectionSpriteTopLeftY;
    this.mainDestinationSpriteTopLeftX = obj.mainDestinationSpriteTopLeftX;
    this.mainDestinationSpriteTopLeftY = obj.mainDestinationSpriteTopLeftY;
    this.moveMessage = obj.moveMessage;
    this.name = obj.name;
    this.premiumSubRequired = obj.premiumSubRequired;
    this.showOps = obj.showOps;
    this.selectionSpriteTopLeftX = obj.selectionSpriteTopLeftX;
    this.selectionSpriteTopLeftY = obj.selectionSpriteTopLeftY;
    this.spriteTopLeftX = obj.spriteTopLeftX;
    this.spriteTopLeftY = obj.spriteTopLeftY;
    this.type = obj.type;
    this.unavailableDescription = obj.unavailableDescription;
    this.unlocked = obj.unlocked;
    this.zIndex = obj.zIndex;
  }

  toStateAwareArea: (areas: IArea[], currentArea: IArea | undefined) => IStateAwareArea = (areas, currentArea) => {
    return asStateAwareArea(this, areas, currentArea);
  };
}